import { render, staticRenderFns } from "./partner-registry.vue?vue&type=template&id=3a102a7c&scoped=true&"
import script from "./partner-registry.ts?vue&type=script&lang=ts&"
export * from "./partner-registry.ts?vue&type=script&lang=ts&"
import style0 from "./partner-registry.scss?vue&type=style&index=0&id=3a102a7c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a102a7c",
  null
  
)

export default component.exports